import { createContext, useContext, ReactNode } from "react";
import { translateDynamicText, getTranslation, type Language } from "@/utils/translations";

interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => string;
  td: (text: string) => string;
  dir: "ltr" | "rtl";
}

const defaultValue: LanguageContextType = {
  language: "en",
  setLanguage: () => {},
  t: (key: string) => getTranslation(key, "en"),
  td: (text: string) => translateDynamicText(text, "en"),
  dir: "ltr",
};

const LanguageContext = createContext<LanguageContextType>(defaultValue);

export const LanguageProvider = ({ children }: { children: ReactNode }) => {
  const language: Language = "en";
  const setLanguage = (_lang: Language) => {}; // No-op, English only

  const t = (key: string): string => getTranslation(key, language);
  const td = (text: string): string => translateDynamicText(text, language);
  const dir = "ltr" as const;

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, td, dir }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);

export type { Language };
